<template>
    <div class="sticky" :style="getPosition">
      <div class="sticky-warp">
        <slot></slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "sticky-slot",
    computed: {
      getPosition() {
        let position = 'relative';
        return 'position:' + position;
      }
    },
    mounted() {
      this.init();
    },
    deactivated() {
      // 复位
      let elWarp = this.$el.querySelector('.sticky-warp');
      elWarp.position = 'absolute';
    },
    methods: {
      init() {
        let el = this.$el;
        let elWarp = this.$el.querySelector('.sticky-warp');
        let top = this.getNumberValue(document.defaultView.getComputedStyle(el).top);
  
        this.addScrollListen(window, () => {
          if (el.getBoundingClientRect().top <= top) {
            elWarp.style.position = 'fixed';
          }
  
          if (el.getBoundingClientRect().top >= 0 && elWarp.style.position != 'absolute') {
            elWarp.style.position = 'absolute';
          }
        });
      },
      getNumberValue(pxValue) {
        let value = String(pxValue).match(/^\-?\+?[0-9]+/g);
        return value ? Number(value) : undefined;
      },
      addScrollListen(window, cb) {
        window.addEventListener('scroll', (event) => {
          cb && cb(event);
        });
      }
    },
  }
  </script>
  
  <style>
  .sticky {
    width: 100%;
  }
  
  .sticky .sticky-warp {
    width: 100%;
    background: inherit;
    will-change: change;
    height: inherit;
    top: inherit;
    display: flex;
    align-items: center;
    background-color: #fff;
  }
  </style>
  